import React, { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { Store } from "@utils/store/ContextStore";
import axios from "axios";
import { getCommunitySingleFeed } from "@queries/community.queries";
import dynamic from "next/dynamic";
const SinglePostModal = dynamic(() => import("@components/post/SinglePostModal"), {
  ssr: false
});
export default function CommunitySinglePostView() {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const router = useRouter();
  const {
    feedID
  } = router.query;
  const [singleFeedData, setSingleFeedData] = useState(null);
  const [openSinglePost, setOpenSinglePost] = useState(false);
  useEffect(() => {
    async function singleFeed(cancelToken) {
      const {
        data,
        err
      } = await getCommunitySingleFeed({
        feedID: feedID,
        accessToken: loggedInUser.accessToken,
        cancelToken
      });
      if (!err && data) {
        setSingleFeedData(data);
        setOpenSinglePost(true);
      }
    }
    let source = null;
    if (feedID) {
      if (window.innerWidth < 750) {
        // if (postType === FEED_TYPES.IMAGE) {
        //   router.push("/post/" + feedID);
        // } else {
        //   router.push("/clip/" + feedID);
        // }
        // **** check for is the feedID for post or clip, currently just getting feedID
        router.push("/post/" + feedID);
        return () => {};
      }
      source = axios.CancelToken.source();
      singleFeed(source.token);
    }
    return () => {
      if (source) source.cancel();
    };
  }, [feedID, router, loggedInUser]);
  return <>
      {singleFeedData && <SinglePostModal postData={singleFeedData} openModal={openSinglePost} closeModal={() => setOpenSinglePost(false)} />}
    </>;
}